var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTelegramCutted = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 11,
  viewBox: "0 0 16 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  className: "dark:fill-white fill-coal-250",
  clipPath: "url(#clip0_13436_8144)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.8359 0.590209V0.766567L13.5239 10.2793C13.4393 10.6837 13.2086 11.0511 12.6753 10.9941C11.3053 10.3651 10.1513 9.39809 8.8566 8.65151L6.94927 10.1841L6.5026 10.2899L6.76527 7.20009L13.1066 2.21035L13.1686 2.00107L12.7206 2.04633L4.85194 6.39942L4.68794 6.4006C3.64394 6.01379 2.28994 5.86917 1.28394 5.4565C1.0666 5.36714 0.977938 5.28426 0.835938 5.11672V5.05793L1.03127 4.78928C5.67327 3.09037 10.4213 1.53901 15.1333 0C15.5813 0.0229265 15.7053 0.259245 15.8359 0.590209Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_13436_8144"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 11,
  fill: "currentColor",
  transform: "translate(0.835938)"
})))));
export default SvgIconTelegramCutted;